// removed by extract-text-webpack-plugin
module.exports = {"grid":"grid-33c21d","grid__column-left":"grid__column-left-438798","grid__column-right":"grid__column-right-1a5bc1","grid__selects":"grid__selects-145831","grid__sort":"grid__sort-2a5d4d","grid__main":"grid__main-b2bf50","grid__main-sports":"grid__main-sports-0b4c79","grid__main-tournaments":"grid__main-tournaments-aee86c","grid__buttons":"grid__buttons-51cd1b","grid__buttons-left":"grid__buttons-left-ec09fd","grid__buttons-right":"grid__buttons-right-155a68"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/grid/style.pcss
// module id = ./src/blocks/grid/style.pcss
// module chunks = 0